// extracted by mini-css-extract-plugin
module.exports = {"container":"modal-chat_container__10lYw","button":"modal-chat_button__BILsh","text":"modal-chat_text__T3QKQ","buttonContainer":"modal-chat_buttonContainer__wpVm6"};